import React from 'react';
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';

import * as S from './style';

import Image from '../../../../../../app/js/components/loggedout/common/Image';
import { CTAButtonWrapper } from '../../../../common/styled-components/styled-components';
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import Routes from "../../../../routes/routes";
import { sliderData } from './data';

const GamesSlider = ({trackPromoPageEvents, settings}) => {
  const sliderSettings = {
    centerMode: false,
    className: "slider-wrapper",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    autoPlay: true,
    dots: true,
    responsive: [
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: 0,
          centerMode: true
        }
      }
    ]
  }
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper noBackground={true}>
      <S.HeadingText>Games that are not really games</S.HeadingText>
      <S.SliderContainer>
        <Slider {...sliderSettings}>
          {sliderData.map((item, index)=>
            <div>
              <S.SlideWrapper>
                <S.SliderImageWapper>
                  <Image src={item.gameImage}/>
                </S.SliderImageWapper>
                <S.QusnAnsWrapper>
                  <Image src={item.BlockIcon}/>
                  <S.Question>{item.ques1}</S.Question>
                  <S.Answer>{item.ans1}</S.Answer>
                  <Image src={item.KajuIcon}/>
                  <S.Question>{item.ques2}</S.Question>
                  <S.Answer>{item.ans2}</S.Answer>
                </S.QusnAnsWrapper>
              </S.SlideWrapper>
            </div>
          )}
        </Slider>
      </S.SliderContainer>
      <CTAButtonWrapper>
        <CTAPrimaryButton darkBlue={true}>
          <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA7'}, true)} >
          {ctaText}
          </Link>
        </CTAPrimaryButton>
      </CTAButtonWrapper>
    </S.ContainerWrapper>
  )
}

export default GamesSlider;